<template>
    <div>
        <section class="m_video"><!-- ビデオ -->
            <div class="video-box" id="video-box">
                <video id="test" class="video-js vjs-default-skin vjs-16-9" data-setup="{}" playsinline />
                <img src="/image/icons/mc_expansion.png" alt="全画面" class="video-exp" @click="requestFullScreen" v-if="!fullscreenFlag">
                <!-- 全画面表示時のコントローラ(ｺｺｶﾗ) -->
                <div v-if="fullscreenFlag && (!playStatus || 0<controllerShowFlag)" class="fullscreen-controller">
                    <div class="fullscreen-top">
                        <div class="fullscreen-title">
                            <div class="fullscreen-album-title">アルバムタイトル</div>
                            <div class="fullscreen-content-title">コンテンツタイトル({{ characters.trial_version }})</div>
                        </div>
                        <div class="fullscreen-add-playlist-button">
                            <a role="button" aria-pressed="true" class="btn btn-outline-light" href="/">+プレイリスト</a>
                        </div>
                    </div>
                    <div class="fullscreen-middle">
                        <div class="cont_item"></div>
                        <div class="cont_item"><!--<img src="/image/icons/mc_back_white.png" width="22px" alt="戻る" @click="back">--></div>
                        <div class="cont_item" v-if="playStatus === true"><img id="stop" src="/image/icons/mc_pause_white.png" width="63px" alt="一時停止" @click="stopVideo()"></div>
                        <div class="cont_item" v-if="playStatus === false"><img id="play" src="/image/icons/mc_play_white.png" width="63px" alt="再生" @click="playVideo()"></div>
                        <div class="cont_item"><!--<img src="/image/icons/mc_previus_white.png" width="22px" alt="次へ" @click="forward()">--></div>
                        <div class="cont_item"></div>
                    </div>
                    <div class="fullscreen-bottom">
                        <ul class="fullscreen-bottom-list">
                            <li class="fullscreen-bottom-item"><div><img id="repeat" src="/image/icons/mc_loop_white.png" alt="リピート" @click="stopVideo()" class="fullscreen-image"></div></li>
                            <li class="fullscreen-bottom-item"><div><img id="shuffle" src="/image/icons/mc_shuffle_white.png" alt="シャッフル" @click="stopVideo()" class="fullscreen-image"></div></li>
                            <li class="fullscreen-bottom-item"><div>{{ currentTime }}</div></li>
                            <li class="fullscreen-bottom-seekbar">
                                <div>
                                    <div v-on:click="seek" class="fullscreen-seekbar" title="Time played : Total time">
                                            <div :style="{ width: this.percentComplete + '%' }" class="fullscreen-player-seeker"></div>
                                    </div>
                                </div>
                            </li>
                            <li class="fullscreen-bottom-item"><div>{{ durationTime }}</div></li>
                            <li class="fullscreen-bottom-item"><div><img id="exit-fullscreen" src="/image/icons/mc_minimize.png" alt="全画面終了" @click="exitFullScreen()" class="fullscreen-image"></div></li>
                        </ul>
                    </div>
                </div>
                <!-- 全画面表示時のコントローラ(ｺｺﾏﾃﾞ) -->
            </div>
        </section>

        <section class="m_control"> <!--コントローラー -->
            <div class="timebar_box">
                <div class="timebar_item1">{{ currentTime }}</div>
                <div v-on:click="seek" class="timebar_item2" title="Time played : Total time">
						<div :style="{ width: this.percentComplete + '%' }" class="player-seeker"></div>
                </div>
                <div class="timebar_item3">{{ durationTime }}</div>
            </div>
            <div class="cont_box" style="clear: both;">
                <div class="cont_item"><!--<img src="/image/icons/mc_loop.png" width="22px" alt="リピート">--></div>
                <div class="cont_item"><!--<img src="/image/icons/mc_back.png" width="22px" alt="戻る" @click="back">--></div>
                <div class="cont_item" v-if="playStatus === true"><img id="stop" src="/image/icons/pause.png" width="63px" alt="一時停止" @click="stopVideo()"></div>
                <div class="cont_item" v-if="playStatus === false"><img id="play" src="/image/icons/play.png" width="63px" alt="再生" @click="playVideo()"></div>
                <div class="cont_item"><!--<img src="/image/icons/mc_previus.png" width="22px" alt="次へ" @click="forward()">--></div>
                <div class="cont_item"><!--<img src="/image/icons/mc_shuffle.png" width="22px" alt="シャッフル">--></div>
            </div>
        </section>

        <img :src="playing_path" />
    </div>
</template>

<script>
    import 'video.js/dist/video-js.css';
    import videojs from 'video.js/dist/video.js';
    // import '@videojs/http-streaming/dist/videojs-http-streaming.js'
    export default {
        name: "store-hls-player",
        props: ['json_characters'],
        data: function () {
            return {
                video: undefined,
                playStatus: false,
                currentSeconds: 0,
                durationSeconds: 0,
                playing_path: String,
                characters: Object,
                fullscreenFlag: false,
                controllerShowFlag: 0,
                supportTouch: undefined,
            }
        },
        mounted() {
            this.supportTouch = 'ontouchend' in document;
            document.addEventListener('fullscreenchange', this.fullscreenListener, false);
            document.addEventListener('webkitfullscreenchange', this.fullscreenListener, false);
            document.addEventListener('mozfullscreenchange', this.fullscreenListener, false);
            document.addEventListener('MSFullscreenChange', this.fullscreenListener, false);
            window.addEventListener("orientationchange", function() {
                console.log("端末の向きが " + screen.orientation.type + "になりました。");
                console.log("portrait-primaryから反時計回りに" + screen.orientation.angle + "°の向きです。");
            });
            console.log("端末の向きが " + screen.orientation.type + "になりました。");
            console.log("portrait-primaryから反時計回りに" + screen.orientation.angle + "°の向きです。");
            let digicon_id='99';
            axios.default
                .get('/digicon/sample/' + digicon_id)
                .then(response => {
                    let data = response.data;
                    console.log(data);
                    this.playing_path = data.fname;
                    console.log('get fname', this.playing_path);
                    // this.setVideoConfig(this.playing_path);
                });
            this.characters = JSON.parse(this.json_characters);
            this.video = videojs("test", {html5: {
                    hls: {
                        withCredentials: true
                    }
                }}, function onPlayerReady() {
                    this.play();
                });
        },
        destroyed() {
            this.video.dispose();
        },
        methods: {
            playVideo: function() {
                // console.log('pushed play button');
                this.video.play();
            },
            stopVideo: function() {
                // console.log('pushed play button');
                this.video.pause();
            },
            convertTimeHHMMSS: function(val) {
                // console.log(val);
	            let hhmmss = new Date(val * 1000).toISOString().substr(11, 8);
	            return hhmmss.indexOf("00:") === 0 ? hhmmss.substr(3) : hhmmss;
            },
            seek: function(e) {
                if (!this.playStatus || e.target.tagName === 'SPAN') {
                    return;
                }

                const el = e.target.getBoundingClientRect();
                const seekPos = (e.clientX - el.left) / el.width;
                // console.log('duration:', this.video.duration(), ', seekPos:', seekPos, ', current:', parseInt(this.video.duration() * seekPos));
                this.video.currentTime(parseInt(this.video.duration() * seekPos));
            },
            setVideoConfig: function(path) {
                console.log('set playing path:', path);
                this.video.on('loadedmetadata', function() {
                    this.durationSeconds = (Number.isNaN(this.video.duration()))?0:parseInt(this.video.duration());
                    this.currentSeconds = 0;
                    console.log('loaded metadata');
                    // console.log('durationsec', this.durationSeconds);
                }.bind(this));
                this.video.on('timeupdate', function() {
                    // console.log('time was updated');
                    this.currentSeconds = parseInt(this.video.currentTime());
                    // console.log('currentsec:', this.currentSeconds, ', currenttime:', this.video.currentTime());
                }.bind(this));
                this.video.on('play', function() {
                    // console.log('start playing');
                    if(this.durationSeconds == 0 && !Number.isNaN(this.video.duration())) {
                        this.durationSeconds = parseInt(this.video.duration());
                    }
                    this.playStatus = true;
                }.bind(this));
                this.video.on('pause', function() {
                    // console.log('start pausing');
                    this.playStatus = false;
                }.bind(this));
                this.video.on('ended', function() {
                    // console.log('start pausing');
                    this.playStatus = false;
                }.bind(this));
                this.video.src(path);
            },
            setVideo: function(path) {
                axios.default
                    .get('/hls/cdn/' + path)
                    .then(response => {
                        let data = response.data;
                        this.playing_path = data.fname;
                        console.log('get fname', this.playing_path);
                        this.setVideoConfig(this.playing_path);
                    });
            },
            requestFullScreen: function() {
                let target = document.getElementById('video-box');
                if (target.webkitRequestFullscreen) {
                    target.webkitRequestFullscreen(); //Chrome15+, Safari5.1+, Opera15+
                } else if (target.requestFullscreen) {
                    target.requestFullscreen(); // HTML5 Fullscreen API仕様
                } else if (target.mozRequestFullScreen) {
                    target.mozRequestFullScreen(); //FF10+
                } else if (target.msRequestFullscreen) {
                    target.msRequestFullscreen(); //IE11+
                } else {
                    this.video.requestFullscreen();
                    // alert('ご利用のブラウザはフルスクリーン操作に対応していません');
                    return;
                }
            },
            exitFullScreen: function() {
                if (document.webkitCancelFullscreen) {
                    document.webkitCancelFullscreen(); //Chrome15+, Safari5.1+, Opera15+
                } else if (document.exitFullscreen) {
                    document.exitFullscreen(); // HTML5 Fullscreen API仕様
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen(); //FF10+
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen(); //IE11+
                } else if (document.cancelFullscreen) {
                    document.cancelFullscreen(); // Gecko Fullscreen API仕様
                } else {
                    this.video.exitFullscreen();
                    // alert('ご利用のブラウザはフルスクリーン操作に対応していません');
                    return;
                }
            },
            fullscreenListener: function() {
                if (document.fullscreenElement) {
                    this.fullscreenFlag = true;
                    this.lockOrientation("landscape");
                    document.addEventListener(this.supportTouch ? 'touchend' : 'mousemove', this.showFullscreenController, false);
                    // console.log(document.fullscreenElement);
                    // console.log(`Entered full-screen mode.`);
                } else {
                    this.fullscreenFlag = false;
                    this.unlockOrientation();
                    document.removeEventListener(this.supportTouch ? 'touchend' : 'mousemove', this.showFullscreenController, false)
                    // this.lockOrientation("any");
                    // console.log(`Leaving full-screen mode.`);
                }
                // console.log('catch full-screen event.')
            },
            lockOrientation: function(mode) {
                if (screen.webkitLockOrientation) {
                    screen.webkitLockOrientation(mode);
                }
                else if (screen.mozLockOrientation) {
                    screen.mozLockOrientation(mode);
                }
                else if (screen.msLockOrientation) {
                    screen.msLockOrientation(mode);
                }
                else if (screen.lockOrientation) {
                    screen.lockOrientation(mode);
                }
                else if (screen.orientation.lock) {
                    screen.orientation.lock(mode);
                } else {
                    console.log('failure locking screen orientation ' + mode);
                    return;
                }
                console.log('screen orientation locked ' + mode);
            },
            unlockOrientation: function() {
                if (screen.webkitUnlockOrientation) {
                    screen.webkitUnlockOrientation();
                }
                else if (screen.mozUnlockOrientation) {
                    screen.mozUnlockOrientation();
                }
                else if (screen.msUnlockOrientation) {
                    screen.msUnlockOrientation();
                }
                else if (screen.unlockOrientation) {
                    screen.unlockOrientation();
                }
                else if (screen.orientation.unlock) {
                    screen.orientation.unlock();
                } else {
                    console.log('failure unlocking screen orientation');
                    return;
                }
                console.log('screen orientation unlocked');
            },
            showFullscreenController: function() {
                // console.log('document was touched!');
                this.controllerShowFlag++;
                setTimeout(function() {
                    this.controllerShowFlag--;
                }.bind(this), 5000);
            },
        },
        computed: {
		    currentTime() {
                return this.convertTimeHHMMSS(this.currentSeconds);
            },
            durationTime() {
                return this.convertTimeHHMMSS(this.durationSeconds);
            },
            percentComplete() {
                return parseInt(this.currentSeconds / this.durationSeconds * 100);
            },
            muted() {
                return this.volume / 100 === 0;
            }
        },
    }
</script>

<style scoped>
 .video-exp {
     z-index: 2147483647;
 }
</style>
